import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useAppState } from ':cloud/contexts/AppStateContext';
import { useNavigationContext } from ':cloud/contexts/NavigationContext';
import { useSimpleBreakpoints } from ':cloud/hooks/useSimpleBreakpoints';
import { AppRoute } from ':cloud/utils/routes';
import { NavigationBar } from ':cloud/widgets/navigation/NavigationBar';
import { ProjectSelector } from ':cloud/widgets/projects/ProjectSelector';

const titleMap: Record<string, string> = {
  [AppRoute.Access.OAuthCreate]: 'Create Client',
  [AppRoute.Access.OAuthEdit]: 'Edit Client',
};

export function TopNav() {
  const { activePage } = useNavigationContext();
  const { selectedProject } = useAppState();
  const history = useHistory();
  const location = useLocation();
  const pathArray = location.pathname.split('/');
  const { isPhone } = useSimpleBreakpoints();
  const isOAuthUpsertClientRoute =
    location.pathname.includes(AppRoute.Access.OAuthCreate) ||
    location.pathname.includes(AppRoute.Access.OAuthEdit);

  const handleBackPress = useCallback(() => {
    if (location.pathname.includes('participate')) {
      history.push(AppRoute.Participate.Home);
    } else {
      history.go(-1);
    }
  }, [history, location.pathname]);

  const showBackButton = useMemo(
    (): boolean =>
      !isPhone &&
      ((pathArray.length > 2 && location.pathname.includes(AppRoute.Participate.Home)) ||
        isOAuthUpsertClientRoute),
    [isOAuthUpsertClientRoute, isPhone, location.pathname, pathArray.length],
  );

  const renderTitle = useMemo(() => {
    if (activePage.id === 'project-dashboard' && isPhone) {
      return selectedProject?.name;
    }

    if (activePage.id === 'project-dashboard') {
      return <ProjectSelector />;
    }

    return titleMap[location.pathname] || activePage.title;
  }, [activePage, location.pathname, isPhone, selectedProject?.name]);

  return (
    <NavigationBar
      handleBackPress={handleBackPress}
      showBackButton={showBackButton}
      title={renderTitle}
    />
  );
}
